<template>
    <div>

        <div class=" mt-5 video-title-wrapper video-uploader-wrapper-block form-group-beside no-border ml-0" :class="(videoobject.length > 0) ? 'has-video': ''" v-if="updateallowed">
            <h3 class="order-header">Video Uploads</h3>
            <p>Click the button below to upload your video (no slates, timecodes, bars and tones), then fill in the video details.</p>
            <vue-dropzone v-show="add_another_video_allowed" class="video-uploader col-10 col-md-6 pl-0 pb-0" ref="videoDropzone" id="dropzoneVideo" :options="dropzoneOptionsVideo" v-on:vdropzone-sending="sendingCallback" v-on:vdropzone-file-added="acceptVideoCallback"></vue-dropzone>
            <vue-dropzone v-show="showReplaceProgressBar" class="video-uploader video-uploader-replace col-10 col-md-6 pl-0 pb-0" ref="videoDropzoneReplace" id="dropzoneVideoReplace" :options="dropzoneReplacementOptionsVideo" v-on:vdropzone-sending="sendingCallback" v-on:vdropzone-file-added="acceptReplaceVideoCallback"></vue-dropzone>
        </div>
        <div class="row mt-0" v-if="videofiles.length > 0">
            <div class="col-12 input-wrapper pl-0">
                <div id="top-element" class="">
                    <div class="video-component-wrapper">
                        <div class="row width-100 no-gutters">
                            <div class="left entrant-left video-filename-listing col-12 col-md-4">
                                <ul>
                                    <draggable class="drag-episode-titles" v-model="videofiles" @start="drag=true" @end="drag=false, updateWeights()">

                                        <li class="video-filename-item" :class="leftSidebarClass(index, video)" v-for="(video, index) in videofiles" @click="videoActive(index)">
                                            <div class="action-icons pull-right hide-me">
                                                <div class="d-inline-block align-middle move pl-3 pr-2" v-if="videofiles.length > 1"><span class="actions">Reorder<br/>Videos</span><i class="fa fa-arrows-v"></i></div>
                                                <div class="d-inline-block align-middle" v-if="videoobject.length > 0 && updateallowed" @click.prevent="activateDeleteVideoPopup(video, index)"><trash class=" delete-video svg-18"></trash></div>
                                            </div>
                                            <div v-if="video.episode_title">{{index+1}} - {{video.episode_title}}</div>
                                            <div v-else>{{index+1}} - Add video details </div>
                                        </li>

                                    </draggable>
                                </ul>
                                <a href="#" @click.prevent="openDropzoneUploader" id="createNewVideoFromLeft" class="btn btn-create" tabindex="-1" v-if="add_another_video_allowed && updateallowed">
                                    <plus_circle class="svg-24"></plus_circle>
                                    <span>Add another video</span>
                                </a>
                            </div>
                            <div class="right omega entrant-right video-entry-right-form col-12 col-md-8 pl-3">
                                <div v-for="(video, index) in videofiles">
                                    <div class="vid-wrapper" v-if="index === activeVideoIndex">
                                        <div class="form-group-beside row no-border video-preview-thumbnail-wrapper">
                                            <div class="col-4">
                                                <video-file v-if="video.asset_id" :show_asset_id="(role === 'admin')" :thumbnail="video.thumbnail" :filename="video.filename" :vfoid="video.id" :asset_id="video.asset_id" :episode="video.episode_title"></video-file>
                                                <div v-else class="no-preview-yet">Video processing.<br>Check back shortly for a preview.</div>
                                            </div>
                                            <div class="col-8">
                                                <div class="upload-date">
                                                    <span class="small bold upper mr-2">Upload Date/Time:</span>
                                                    <span class="small">{{ video.created_at | moment("h:mm:ss a MMMM D, YYYY") }}</span>
                                                </div>
                                                <div class=" d-inline-block w-100">
                                                    <span class="small bold upper mr-2 d-inline-block">Video File Status:</span>
                                                    <div class="small d-inline-block valign-middle" v-if="video.id && !isadmin" v-text="video.status"></div>
                                                    <Select2 class="d-inline-block video-status-dropdown-select" v-if="isadmin && video.id" v-model="video.status" :options="VIDEOSTATUSES" :settings="{placeholder: 'Video File Status'}" @change="applyStatusChange(video)" >
                                                    </Select2>
                                                </div>
                                                <div class=" d-inline-block w-100" v-if="isadmin && video.asset_id">
                                                    <span class="small bold upper mr-2 d-inline-block">Brightcove ID:</span>
                                                    <div class="small d-inline-block valign-middle" v-text="video.asset_id"></div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="form-group-beside row video-file-field-fullwrapper no-gutters">
                                            <div class="col-2 col-md-6">
                                                <label class="mb-0 pr-1" style="line-height: 21px;">Video File:</label>
                                                <div class="description">No slates, timecodes, bars & tones</div>
                                            </div>
                                            <div class="pl-3 video-file-field-wrapper col-10 col-md-6 input-wrapper position-relative" :class="(role == 'admin') ? 'is-admin-viewer': ''" v-if="updateallowed && video.status != 'Video Approved'">
                                                <div class="filename" v-text="video.filename"></div>
                                                <div class="button-wrapper position-absolute file-button-actions" v-if="video.id">
                                                    <a v-if="isadmin" :href="video.signed_url" download class="d-block btn btn-primary btn-padding-smaller mb-1"><download class="svg-24"></download> Download</a>
                                                    <a v-if="video.status != 'Approved'" href="#" class="d-block btn btn-primary btn-padding-smaller" @click.prevent="activateReplaceVideo(video, index)"><trash class="svg-24"></trash> Replace </a>
                                                </div>
                                            </div>
                                            <div class="col-10 col-md-6 input-wrapper position-relative" v-if="!updateallowed || video.status == 'Video Approved'">
                                                <div class="filename" v-text="video.filename"></div>
                                                <div class="button-wrapper position-absolute file-button-actions" v-if="video.id">
                                                    <a v-if="isadmin" :href="video.signed_url" download class="d-block btn btn-primary btn-padding-smaller"><download class="svg-24"></download> Download</a>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="form-group pt-0 closed-caption-upload-wrapper" v-if="requiredfields['closedCaptionFieldRequired'] != 'No' && video.id" :class="(video.required && video.required.CCFileUrl) ? 'required' : ''">
                                            <div class="form-group-beside row no-gutters" :class="video.CCFileUrl && video.id ? 'locked' : ''">
                                                <div class="col-2 col-md-6">
                                                    <label class="closed-caption-label entry-field__label" :class="video.CCFileUrl && video.id ? 'cc-file-exists ' : 'no-cc-file'" for="closed_caption">Closed Captioning Upload <em class="yellow no-style" v-if="requiredfields['closedCaptionFieldRequired'] == 'Required'">*</em></label>
                                                    <div class="description">Timecodes must start at the 00 hour mark (00:00:00 timecode format) not at hour 01. File type must be .scc or .vtt</div>
                                                </div>
                                                <div class="col-10 col-md-6 input-wrapper pl-3" v-if="updateallowed && video.status != 'Video Approved'">
                                                    <a v-if="!video.CCFileUrl && !video.ccFile" href="#" class="btn btn-primary displaybloc" @click.prevent="activateDropzone(index)"><upload class="svg-24"></upload> Upload</a>
                                                    <div id="closed_caption" class="form-control-left-border form-control filename" v-if="video.CCFileUrl">
                                                        <span class="cc-filename">{{video.CCFilename}}</span>
                                                        <span class="cc-filename-trash p-2 pointer" @click.prevent="activateDeleteCCFilePopup(video, index)"><trash class="svg-24"></trash></span>
                                                        <div v-if="isadmin" class="d-flex">
                                                            <a  :href="video.caption_file_signed_url" download class="d-block btn btn-primary btn-padding-smaller mr-2 "><download class="svg-24"></download> Download CC File</a>
                                                            <a  :href="`/video/ingest_caption/`+video.id" @click.prevent="ingestCaption(video, index)" download class="d-block btn btn-primary btn-padding-smaller"><download class="svg-24"></download> Re-ingest CC File</a>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="input-wrapper" :class="video.CCFileUrl ? 'col-10 col-md-6' : 'col-10 col-md-12'" v-if="updateallowed && video.status != 'Video Approved'">
                                                    <vue-dropzone v-show="video.ccFile" class="video-placeholder" v-if="!video.CCFileUrl && video.id" ref="myVueDropzone" :id="'dropzone'+index" :options="dropzoneOptions" v-on:vdropzone-success="successCallback" v-on:vdropzone-sending="sendingCallback" v-on:vdropzone-file-added="acceptCallback"></vue-dropzone>
                                                </div>

                                                <div class="col-10 col-md-6 input-wrapper" v-if="!updateallowed || video.status == 'Video Approved'">
                                                    <span class="readonly pl-2" v-text="video.CCFilename"></span>
                                                </div>

                                            </div>
                                            <div class="form-group-beside row" :class="video.CCFileUrl && video.id ? 'locked' : ''" v-if="isadmin && video.CCFileUrl">
                                                <label :class="video.CCFileUrl && video.id ? 'cc-file-exists ' : 'no-cc-file'" for="closed_caption">Closed Captioning Status </label>
                                                <div>{{ video.cc_status }}</div>

                                            </div>
                                            <div class="form-group-beside row" :class="video.CCFileUrl && video.id ? 'locked' : ''" v-if="isadmin && video.CCFileUrl">
                                                <label class="col-2 col-md-6" :class="video.CCFileUrl && video.id ? 'cc-file-exists ' : 'no-cc-file'" for="closed_caption">Closed Captioning Offset (+/- in seconds)</label>
                                                <input type="text" class="form-control col-md-6" v-model="video.cc_file_offset" >
                                                <button class="offset-6 mt-2 mb-1" v-if="video.cc_file_offset || video.cc_file_offset===0" @click.prevent="video.cc_file_offset+=' processing'; applyChange(video)">Process Closed Caption Offset</button>
                                            </div>
                                        </div>
                                        <div class="video-text-info-wrapper" v-if="video.id">

                                            <div class="form-group-beside row" :class="(video.readonly_episodetitle) ? 'locked' : (video.required && video.required.episode_title) ? 'required' : ''">
                                                <label for="episode_title" class="col-2 col-md-6">Episode Title <em class="yellow no-style" v-if="requiredfields['episodeTitleFieldRequired'] == '1'">*</em></label>
                                                <div class="col-10 col-md-6 input-wrapper">
                                                    <input type="text" ref="episode_title" v-if="updateallowed" id="episode_title" class="form-control" placeholder="If movie/special, repeat program name" v-model="video.episode_title" @blur="titleCaseBlur('episode_title', index, $event)" @keyup="titleCase(video, $event)" @change.prevent="applyChange(video)" :readonly="video.readonly_episodetitle && !isadmin" :disabled="(is_viewing_mode)?true:false">
                                                    <span v-text="video.episode_title" v-if="!updateallowed" class="readonly pl-2"></span>
                                                </div>
                                            </div>
                                            <div class="form-calendar form-group-beside row" :class="(video.required && video.required.hold_date) ? 'required' : ''">
                                                <label for="site_live_date" class="col-2 col-md-6">
                                                    <div>Episode Air Date: <em class="yellow no-style" v-if="requiredfields['holdDateFieldRequired'] == '1'">*</em></div>
                                                </label>
                                                <div class="col-10 col-md-6 input-wrapper input-wrapper-date">
                                                    <calendar class="svg-24 svg-black calendar-icon-position" title="Toggle" data-toggle></calendar>
                                                    <flat-pickr id="site_live_date" v-model="video.hold_date" :config="dateConfig"
                                                                placeholder="Select date" v-on:input="applyChange(video, index)" v-if="updateallowed"></flat-pickr>
                                                    <span class="readonly-date" v-text="video.hold_date" v-if="!updateallowed"></span>
                                                    <div class="input-group-append">

                                                        <a class="date-clear-button" type="button" title="Clear" data-clear v-if="updateallowed">
                                                            <close class="svg-18"></close>
                                                        </a>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <modal v-if="modalTrigger" @close="modalTrigger = false">
                            <h3 slot="header">Select Video File</h3>
                            <div class="content" slot="body">
                                <div class="existing-videos-wrapper">
                                    <Select2 v-model="exisitingVideoSelected" :options="existingvideos" :settings="{placeholder: 'Select Video'}" ></Select2>
                                </div>
                            </div>
                            <div class="form-group-submit clearfix" slot="footer">
                                <button class="btn btn-cancel btn-transparent pull-left" @click.prevent="modalTrigger = false">Close</button>
                                <button class="pull-right" @click.prevent="saveClonedVideo">Add video</button>
                            </div>
                        </modal>

                        <modal v-if="modalTriggerConfirmDelete" @close="modalTriggerConfirmDelete = false">
                            <h3 slot="header">Removing Video File</h3>
                            <div class="content" slot="body">
                                <div v-if="videoModalDelete.filename">Are you sure you want to remove {{videoModalDelete.filename}} from this order? </div>
                                <div v-else>Are you sure you want to remove this item?</div>
                            </div>
                            <div class="form-group-submit clearfix" slot="footer">
                                <button class="btn btn-cancel btn-transparent pull-left" @click.prevent="modalTriggerConfirmDelete = false">Cancel</button>
                                <button class="pull-right" @click.prevent="deleteVideo(videoModalDelete.id)">Yes, Remove</button>
                            </div>
                        </modal>

                        <modal v-if="modalTriggerConfirmCCRemove" @close="modalTriggerConfirmCCRemove = false">
                            <h3 slot="header">Removing Closed Captioning File</h3>
                            <div class="content" slot="body">
                                <div v-if="videoModalDelete.CCFilename">Are you sure you want to remove {{videoModalDelete.CCFilename}} from this order?</div>
                                <div v-else>Are you sure you want to remove this item?</div>
                            </div>
                            <div class="form-group-submit clearfix" slot="footer">
                                <button class="btn btn-cancel btn-transparent pull-left" @click.prevent="modalTriggerConfirmCCRemove = false">Cancel</button>
                                <button class="pull-right" @click.prevent="removeCCFile(videoModalDelete.id)">Yes, Remove</button>
                            </div>
                        </modal>

                        <modal v-if="modalTriggerThirdPartySubmit" @close="modalTriggerThirdPartySubmit = false">
                            <h3 slot="header"></h3>
                            <div class="content" slot="body">
                                <h3>Thank you, the video(s) have been submitted.</h3>
                            </div>
                            <div class="form-group-submit clearfix" slot="footer">
                                <button class="btn btn-cancel btn-transparent pull-left" @click.prevent="modalTriggerThirdPartySubmit = false">Close</button>
                            </div>
                        </modal>

                    </div>
                </div>
            </div>
        </div>
        <div class="mt-4 pull-right">
            <a v-if="is3rd_party && updateallowed" type="submit" @click.prevent="thirdPartySubmit" class="btn btn-primary btn-step-next">
                <checkmark class="svg-24"></checkmark>
                <div>
                    <span class="submit-text">Submit Video</span>
                </div>
            </a>
        </div>
    </div>
</template>

<script>
import Checkmark from "./icons/checkmark";
const VIDEOSTATUSES = [
    'Approved',
    'Need More Info',
    'Submitted',
    'Upload Successful',
    'Processing',
    'Failed',
];

import upload from './icons/upload.vue';
import play from './icons/play.vue';
import calendar from './icons/calendar.vue';
import plus_circle from "./icons/plus_circle.vue";
import save from "./icons/save.vue";
import trash from "./icons/trash.vue";
import download from "./icons/download.vue";
import close from "./icons/close.vue";

// import dropzoneS3Single from './DropZoneS3Single.vue';
import modal from './Modal.vue';
import videoFile from './Videofile.vue';
import Select2 from 'v-select2-component';
import vueDropzone from 'vue2-dropzone';
import 'vue2-dropzone/dist/vue2Dropzone.min.css';
import AWS from 'aws-sdk/global';
import S3 from 'aws-sdk/clients/s3';


export default {
    name: "VideoUploadComponent",
    components: {
        Checkmark,
        modal, Select2, vueDropzone, videoFile, upload, play, calendar, save, plus_circle, trash, download, close},
    props: {
        videofilestatuses: Array,
        initialdata : Array,
        videoobject : Array,
        entryid: Number,
        isadmin: {
            type: Boolean,
            default: false,
        },
        updateallowed: {
            type: Boolean,
            default: true,
        },
        submitterid: Number,
        nominee_video_status: String,
        captioning: String,
        bucketname: String,
        max_videos: Number,
        role: String,
        is3rd_party: {
            type: Boolean,
            default: false,
        },
        is_viewing_mode: Boolean
    },
    computed: {
        add_another_video_allowed: function() {
            if (this.video_objects.length < this.max_videos) {
                return true;
            }
            return false;
        }
    },
    data() {
        return {
            VIDEOSTATUSES: VIDEOSTATUSES,
            video_objects: this.videoobject,
            maxvideos: 20,
            episodeArray: ['Select'].concat(Array.from({length: 30}, (_, index) => index + 1)),
            modalTrigger: false,
            modalTriggerConfirmDelete: false,
            modalTriggerConfirmCCRemove: false,
            modalTriggerConfirmSubmit: false,
            modalTriggerThirdPartySubmit:false,
            entryVideoStatus: this.nominee_video_status,
            requiredfields: {
                'closedCaptionFieldRequired': 'Required',
                'episodeTitleFieldRequired': 1,
                'holdDateFieldRequired': 1,
            },
            confirmSubmitClicked: false,
            buttonDisabled: true,
            videoModalDelete: '',
            videostatus: '',
            videofiles: [],
            existingvideos: [],
            exisitingVideoSelected: '',
            activeVideoIndex: 0,
            maxWords: 50,
            numberOver: '',
            showWordCountMax: false,
            showReplaceProgressBar: false,
            dateConfig: {
                wrap: true,
                dateFormat: 'm-d-Y',
                minDate: "1.1.2024",
                maxDate: "12.31.2024"
            },
            videoObjectDetails: {
                'id': '',
                'filename': '',
                'CCFilename': '',
                'CCFileUrl': '',
                'episode_title': '',
                'required': {
                    'CCFileUrl': false,
                    'episode_title': false,
                }
            },
            dropzoneOptions: {
                thumbnailWidth: 150,
                autoQueue: false,
                // The URL will be changed for each new file being processing
                url: '/',
                maxFilesize: 300000, // 300GB
                timeout: 172800000, // 48 hours in miliseconds
                // Since we're going to do a `PUT` upload to S3 directly
                method: 'put',
                dictDefaultMessage: '',
                addRemoveLinks: true,
                dictCancelUpload: "Cancel Upload",
                // Hijack the xhr.send since Dropzone always upload file by using formData
                // ref: https://github.com/danialfarid/ng-file-upload/issues/743
                // sending (file, xhr) {
                //     let _send = xhr.send
                //     xhr.send = () => {
                //         _send.call(xhr, file)
                //     }
                // },
                // Upload one file at a time since we're using the S3 pre-signed URL scenario
                parallelUploads: 10,
                uploadMultiple: false,
                // Content-Type should be included, otherwise you'll get a signature
                // mismatch error from S3. We're going to update this for each file.
                header: '',
                // We're going to process each file manually (see `accept` below)
                autoProcessQueue: true,
                acceptedFiles: '.vtt,.scc',
                // accept: this.acceptCallback, // use our custom acceptCallback
                // canceled : this.abortUpload,
                // complete: this.completeUpload,
                sending: function(file, xhr) {
                    var _send = xhr.send;
                    xhr.send = function() {
                        _send.call(xhr, file);
                    }
                }
            },
            dropzoneOptionsVideo: {
                thumbnailWidth: 150,
                autoQueue: false,
                addRemoveLinks: true,
                dictCancelUpload: "Cancel Upload",
                // The URL will be changed for each new file being processing
                url: '/',
                maxFilesize: 300000, // 300GB
                timeout: 172800000, // 48 hours in miliseconds
                // Since we're going to do a `PUT` upload to S3 directly
                method: 'put',
                dictDefaultMessage: 'Browse for Videos',
                // Upload one file at a time since we're using the S3 pre-signed URL scenario
                parallelUploads: 10,
                uploadMultiple: true,
                // Content-Type should be included, otherwise you'll get a signature
                // mismatch error from S3. We're going to update this for each file.
                header: '',
                // We're going to process each file manually (see `accept` below)
                autoProcessQueue: true,
                acceptedFiles: '.mp4,.mov',
                // accept: this.acceptCallback, // use our custom acceptCallback
                // canceled : this.abortUpload,
                complete: this.successVideoCallback,

            },
            dropzoneReplacementOptionsVideo: {
                thumbnailWidth: 150,
                autoQueue: false,
                // The URL will be changed for each new file being processing
                url: '/',
                maxFilesize: 300000, // 300GB
                timeout: 172800000, // 48 hours in miliseconds
                // Since we're going to do a `PUT` upload to S3 directly
                method: 'put',
                dictDefaultMessage: 'Browse for Videos',
                // Upload one file at a time since we're using the S3 pre-signed URL scenario
                parallelUploads: 10,
                uploadMultiple: true,
                // Content-Type should be included, otherwise you'll get a signature
                // mismatch error from S3. We're going to update this for each file.
                header: '',
                // We're going to process each file manually (see `accept` below)
                autoProcessQueue: true,
                acceptedFiles: '.mp4,.mov',
                // accept: this.acceptCallback, // use our custom acceptCallback
                // canceled : this.abortUpload,
                complete: this.successVideoReplaceCallback,
                sending: function(file, xhr) {
                    // console.log('sending', file);
                    file.s3upload.send(function(err, data) {
                        if (err) {
                            theDropzone.emit("error", file, err.message);
                        } else {
                            theDropzone.emit("complete", file);
                        }
                    });
                    //
                    // var _send = xhr.send;
                    // xhr.send = function() {
                    //     _send.call(xhr, file);
                    // }
                }
            }
        }
    },
    created: function() {
    },
    mounted () {
        AWS.config.region = 'us-west-2'; // Region
        AWS.config.credentials = new AWS.CognitoIdentityCredentials({
            IdentityPoolId: 'us-west-2:f916f8a9-1780-4953-a74b-75d5607638af',
        });
        this.videofiles = this.setInitialVideoFile();
        let app = this;
        if (this.$refs.videoDropzone && this.$refs.videoDropzone.dropzone) {
            this.$refs.videoDropzone.dropzone.uploadFiles = function (files) {
                // console.log('[uploadFiles] Override', files);
                for (var j = 0; j < files.length; j++) {
                    var file = files[j];
                    app.sendVideoFile(file, app.$refs.videoDropzone.dropzone);
                }
            }
        }
        if (this.$refs.videoDropzoneReplace && this.$refs.videoDropzoneReplace.dropzone) {
            this.$refs.videoDropzoneReplace.dropzone.uploadFiles = function (files) {
                // console.log('[uploadFiles] Override', files);
                for (var j = 0; j < files.length; j++) {
                    var file = files[j];
                    app.sendVideoFile(file, app.$refs.videoDropzoneReplace.dropzone);
                }
            }
        }
    },
    methods: {
        sendVideoFile(file, dzelement) {
            file.s3upload.send(function(err, data) {
                if (err) {
                    // console.log(err.message);
                    dzelement.emit("error", file, err.message);
                } else {
                    dzelement.emit("complete", file);
                }
            });

            // listen to the AWS httpUploadProgress event, and emit an equivalent Dropzone event
            file.s3upload.on('httpUploadProgress', function(progress) {
                if (progress.total) {
                    var percent = ((progress.loaded * 100) / progress.total);
                    dzelement.emit('uploadprogress', file, percent, progress.loaded);
                }
            });
        },
        thirdPartySubmit(){
            let app = this;
            let token = uploaderToken;
          // trigger endpoint to send email to submitter

          let actionUrl = `/videouploadcomplete/${token}`;
            app.modalTriggerThirdPartySubmit=true;
            window.axios(
              {
                  method: 'POST',
                  url: actionUrl,
                  data: {}
              }).then(function(response) {

          }).catch(function (error) {
              //  handle error
              app.modalTriggerThirdPartySubmit=false;
              alert('There was a problem completing your submission. Please notify the submitter.')
              // console.log('This is the error returned', error);
          });

        },
        ingestCaption(video, index) {
            let app = this;
            app.video_objects[index].CCFilename = 'Processing...';
            window.axios(
                {
                    method: 'GET',
                    url: `/video/ingest_caption/`+video.id,
                }).then(function(response) {
                    console.log(response);
                    app.video_objects[index].CCFilename = 'Ingesting. Check back shortly.';
                }).catch(function (error) {
                    // @TODO pass the error on to the user so they know
                    //  handle error
                    console.log('This is the error returned', error);
                    app.video_objects[index].CCFilename = 'ERROR!';
                });
        },
        activateReplaceVideo(video, index) {
            // TBD still
            // console.log('lets replace a video', video);
            this.$refs.videoDropzoneReplace.$el.click();
        },
        setInitialVideoFile: function() {
            let app = this;
            let videoF = [];

            // inject user data in
            app.video_objects.forEach(function(video,index) {
                video.required = {
                    'CCFileUrl': false,
                    'episode_title': false,
                };
                videoF[index] = video;
            });

            // make sure none of them are undefined
            var filtered = videoF.filter(function(item) {
                return item !== undefined;
            });
            return filtered
        },
        updateWeights: function() {
            let app = this;
            var weightIdValues = app.videofiles.map(function(x, index){
                var weightIdObject = {
                    'id': x.id,
                    'weight': index
                };
                return(weightIdObject)
            });
            // console.log('updating weights new weights are');

            let actionUrl = `/video/updateweights`;
            window.axios(
                {
                    method: 'POST',
                    url: actionUrl,
                    data: {
                        order_id: app.entryid,
                        weights: weightIdValues
                    }
                }).then(function(response) {
                    // console.log('response');
                }).catch(function (error) {
                    // @TODO pass the error on to the user so they know
                    //  handle error
                    // console.log('This is the error returned', error);
                });
        },
        sendUpdatedObject: function(object_data) {
            let app = this;

            let vfo_id = app.videofiles[app.activeVideoIndex].id;
            let actionUrl = `/video/update/${vfo_id}`;

            window.axios(
                {
                    method: 'POST',
                    url: actionUrl,
                    data: object_data
                }).then(function(response) {
                    app.modalTrigger = false;
                    if(app.confirmSubmitClicked) {
                        app.underlineFields();
                    }
                    // //console.log(response.data.object.status);
                    // update the status
                    if (response.data.object && response.data.object.status) {
                        app.videofiles[app.activeVideoIndex].status = response.data.object.status;
                        app.videofiles[app.activeVideoIndex].cc_file_offset = response.data.object.cc_file_offset;
                        app.videofiles[app.activeVideoIndex].cc_status = response.data.object.cc_status;
                    }
                }).catch(function (error) {
                    // @TODO pass the error on to the user so they know
                    //  handle error
                    alert('There was an error updating your video, please try again.')
                    // console.log('This is the error returned', error);
                });
        },
        applyStatusChange: function(video) {
            let app = this;
            this.sendUpdatedObject({
                id: video.id,
                order_id: app.entryid,
                status: video.status,
            });
        },
        applyChange: function(video, index) {
            let app = this;

            this.sendUpdatedObject({
                id: video.id,
                order_id: app.entryid,
                filename: video.filename,
                episode_title: video.episode_title,
                weight: video.weight,
                hold_date: video.hold_date,
                cc_file_offset: video.cc_file_offset,
            });
        },
        videoActive: function(index) {
            let app = this;
            app.activeVideoIndex = index;
        },
        addNewVideo: function() {
            let app = this;
            app.activeVideoIndex = app.videofiles.length;
            app.videofiles.push({
                'id': '',
                'filename': '',
                'episode_title': '',
                'required': {
                    'season': false,
                    'episode_title': false
                }
            })
        },
        selectFileModal: function(index) {
            // This looks up all the current videos the user has
            let app = this;
            app.activeVideoIndex = index;
            window.axios(
                {
                    method: 'GET',
                    url: `/api/upload/user_vfos/${app.submitterid}/${app.entryid}`,
                })
                .then(function(response) {
                    app.existingvideos = response.data;
                    // This adds the filename as a 'text' value for the select2 vue component
                    app.existingvideos.forEach(function(i,v) {
                        app.existingvideos[v].text = i.filename + ' - '+i.created_display
                    });
                    app.modalTrigger = true;
                }).catch(function (error) {
                // handle error
                // console.log('This is the error returned', error);
            });
        },
        saveClonedVideo: function() {
            let app = this;

            // This finds the file details selected
            var selectedFile = app.existingvideos.filter(function(number) {
                return number.id == app.exisitingVideoSelected;
            });
            app.videofiles[app.activeVideoIndex].filename = selectedFile[0].filename;
            app.videofiles[app.activeVideoIndex].CCFilename = selectedFile[0].CCFilename;
            app.videofiles[app.activeVideoIndex].CCFileUrl = selectedFile[0].CCFileUrl;
            app.videofiles[app.activeVideoIndex].status = selectedFile[0].status;
            app.modalTrigger = false;
            var weight = app.activeVideoIndex;

            // // console.log(selectedFile);
            window.axios(
                {
                    method: 'POST',
                    data: {
                        weight: weight
                    },
                    url: '/video/clone/'+selectedFile[0].id+'/'+app.entryid
                })
                .then(function(response) {
                    // //console.log(response, 'this is returned from the clone');
                    // Then save the video id in the Axios return .... like the following
                    if (selectedFile[0].id == response.data) {
                        app.videofiles[app.activeVideoIndex].id = selectedFile[0].id;
                        app.applyChange(app.videofiles[app.activeVideoIndex], app.activeVideoIndex);
                    } else {
                        alert('There was a problem attaching the video');
                    }
                }).catch(function (error) {
                // handle error
                // console.log('This is the error returned', error);
                alert('There was a problem attaching the video');
            });

        },
        wordCountFixer: function(text) {
            let app = this;
            if(text != null) {
                let numberWords = window.countWords(text);
                if (numberWords > app.maxWords) {
                    app.numberOver = numberWords - app.maxWords;
                    app.showWordCountMax = true;
                } else {
                    app.showWordCountMax = false;
                }
            }
        },
        sendVideoFileStatus(file) {
            let app = this;
            let actionUrl = '/video/create';
            // console.log('creating file status', file);
            axios.post(actionUrl, {
                    order_id: app.entryid,
                    submitter_id: app.submitterid,
                    video_file_url: file.s3key,
                    video_filename: file.name
                })
                .then(function(response) {
                    // console.log('created video object',response);
                    // push in the videofile object based on the response
                    app.video_objects.push(response.data.vfo);
                    app.videofiles = app.setInitialVideoFile();
                    app.$refs.videoDropzone.dropzone.removeFile(file);
                }).catch(function (error) {
                    // handle error
                    // console.log('VideoFileUpload error', error)
                });
        },
        sendUpdatedVideoFileStatus(file) {
            let app = this;
            let vfo_id = app.videofiles[app.activeVideoIndex].id;
            let actionUrl = `/video/update/${vfo_id}`;
            // console.log('send updated file status', file);
            axios.post(actionUrl, {
                id: vfo_id,
                order_id: app.entryid,
                video_file_url: file.s3key,
                video_filename: file.name
            })
                .then(function(response) {
                    app.videofiles[app.activeVideoIndex].filename = file.name;
                    app.videofiles[app.activeVideoIndex].S3key = file.s3key;
                }).catch(function (error) {
                // handle error
                // console.log('CC error', error)
                alert('error posting video update')
            });
        },
        sendFileStatus(file) {
            let app = this;
            let vfo_id = app.videofiles[app.activeVideoIndex].id;
            let actionUrl = `/video/update/${vfo_id}`;
            // console.log('send file status', file);
            axios.post(actionUrl, {
                    id: vfo_id,
                    order_id: app.entryid,
                    CCFileUrl: file.s3key,
                    CCFilename: file.name
                })
                .then(function(response) {
                    app.videofiles[app.activeVideoIndex].CCFilename = file.name;
                    app.videofiles[app.activeVideoIndex].CCFileUrl = file.s3key;
                    app.videofiles[app.activeVideoIndex].ccFile = true;
                }).catch(function (error) {
                // handle error
                // console.log('CC error', error)
                app.videofiles[app.activeVideoIndex].CCFileUrl = '';
            });
        },
        cancelAllUploads() {
            // console.log('cancel');
            this.dropzone.removeAllFiles(true);
        },
        abortUpload(file) {
            // console.log('Abort Upload');
            if (file.s3upload) file.s3upload.abort();
            this.sendFileStatus(file);
        },
        successVideoCallback(file){
            if (file.status === "canceled") {
                return;
            }
            // console.log('success Video', file);

            this.sendVideoFileStatus(file);
        },
        successVideoReplaceCallback(file) {
            // console.log('success REPLACEMENT Video', file);
            if (file.status === "canceled") {
                return;
            }
            this.showReplaceProgressBar = false;
            this.sendUpdatedVideoFileStatus(file);
            // Removing the reference to the asset_id after replace callback
            // This allows for better UX to see video being processed
            this.videofiles[this.activeVideoIndex].asset_id = '';
        },
        successCallback(file, response){
            // console.log('success', file);
            // console.log(response);

            this.sendFileStatus(file);
        },
        sendingCallback(file, xhr, formData) {
            // console.log('sending');
            xhr.timeout = 99999999;
        },
        acceptVideoCallback(file, dzone) {
            // console.log('acceptVideoCallback method');
            let vm = this;
            var ext = file.name.substr(file.name.lastIndexOf('.') + 1);
            var filename = `Honors/2024/videos/video_${vm.entryid}_${vm.submitterid}_${Date.now()}.${ext}`;
            file.s3key = filename;
            var params = {Bucket: vm.bucketname, Key: filename, Body: file};
            // add an S3 managed upload instance to the file
            file.s3upload = new S3.ManagedUpload({params: params});
            //done();
            vm.$refs.videoDropzone.dropzone.processFile(file);
        },
        acceptReplaceVideoCallback(file, dzone) {
            // console.log('NEW acceptVideoCallback method');
            this.showReplaceProgressBar = true;
            let vm = this;
            var ext = file.name.substr(file.name.lastIndexOf('.') + 1);
            var filename = `Honors/2024/videos/video_${vm.entryid}_${vm.submitterid}_${Date.now()}.${ext}`;
            file.s3key = filename;
            var params = {Bucket: vm.bucketname, Key: filename, Body: file};
            // add an S3 managed upload instance to the file
            file.s3upload = new S3.ManagedUpload({params: params});
            //done();
            vm.$refs.videoDropzoneReplace.dropzone.processFile(file);
        },
        acceptCallback(file, dzone) {
            // console.log('acceptCallback method');
            let vm = this;
            var ext = file.name.substr(file.name.lastIndexOf('.') + 1);
            var filename = `2024/captions/captionfile_${vm.entryid}_${vm.submitterid}_${Date.now()}.${ext}`;
            // //console.log(this);

            vm.videofiles[vm.activeVideoIndex].ccFile = true;

            // get signed url for upload
            let app = this;
            axios.get('/api/signed_url', {
                    params: {
                        filename: filename,
                        filetype: file.type
                    }
                })
                .then(function(response) {
                    // console.log(response.data.signed_url);
                    file.s3key = `Honors/${filename}`;
                    app.$refs.myVueDropzone[0].dropzone.URL = response.data.signed_url;
                    app.$refs.myVueDropzone[0].dropzone.options.url = response.data.signed_url;
                    // console.log(app.$refs.myVueDropzone[0].dropzone);
                    app.$refs.myVueDropzone[0].dropzone.processFile(file);
                    vm.videofiles[vm.activeVideoIndex].ccFile = false;
                })


            // // console.log(file, 'file');



            // options for the managed upload for this accepted file
            // define the bucket, and the S3 key the file will be stored as

            //this.sendFileStatus(file);
            // automatically start the uploads (comment it out if you want to use the start upload button)
            //setTimeout(() => vm.dropzone.processFile(file))
        },

        sendFile(file, dzelement) {
            // console.log('sending file through AWS sdk');
            file.s3upload.send(function(err, data) {
                if (err) {
                    // console.log(err.message);
                    dzelement.emit("error", file, err.message);
                } else {
                    // console.log('complete');
                    file.status = Dropzone.SUCCESS;
                    dzelement.emit("success", file, 'success', null);
                    dzelement.emit("complete", file);

                }
            });

            // listen to the AWS httpUploadProgress event, and emit an equivalent Dropzone event
            file.s3upload.on('httpUploadProgress', function(progress) {
                if (progress.total) {
                    var percent = ((progress.loaded * 100) / progress.total);
                    dzelement.emit('uploadprogress', file, percent, progress.loaded);
                }
            });
        },
        activateDropzone: function(index) {
            $('#dropzone' + index).click();
        },
        activateDeleteVideoPopup(video, index) {
            let app = this;
            app.modalTriggerConfirmDelete = true;
            app.videoModalDelete = video;
            app.activeVideoIndex = index;
        },
        deleteVideo: function(videoid) {
            let app = this;
            if(!videoid) {
                app.videofiles.splice(app.activeVideoIndex, 1);
                app.modalTriggerConfirmDelete = false;
                if(app.activeVideoIndex != 0) {
                    app.activeVideoIndex = app.activeVideoIndex-1;
                } else {
                    app.activeVideoIndex = 0;
                }
                return;
            }

            let indexlist= [];
            app.videofiles.splice(app.activeVideoIndex, 1);
            app.videofiles.forEach(function(video, index){
                indexlist[index] = video.id;
            });
            // not sure we need this?
            // console.log(indexlist);

            let actionUrl = `/video/detach`;
            window.axios(
                {
                    method: 'POST',
                    data: {
                        'video_id':videoid,
                        'token': false,
                        'indexlist' : indexlist,
                    },
                    url: actionUrl,
                }).then(function(response) {
                app.modalTriggerConfirmDelete = false;
                //app.videofiles.splice(app.activeVideoIndex, 1)
                app.activeVideoIndex = 0;
                window.location.reload();
            }).catch(function (error) {
                // handle error
                // console.log('This is the error returned', error);
            });
        },
        setDropzoneClickIndex: function(index) {
            this.dropzoneIndex = index;
        },
        underlineFields: function() {
            let app = this;
            let submitFormBlock = false;
            app.videofiles.forEach(function(i,v) {
                if(!i.CCFileUrl && app.requiredfields['closedCaptionFieldRequired'] == 'Required') {
                    app.videofiles[v].required.CCFileUrl = true;
                    submitFormBlock = true;
                } else {app.videofiles[v].required.CCFileUrl = false;}
                if(!i.episode_title && app.requiredfields['episodeTitleFieldRequired'] == '1') {
                    app.videofiles[v].required.episode_title = true;
                    submitFormBlock = true;
                } else {app.videofiles[v].required.episode_title = false;}
                if(!i.hold_date && app.requiredfields['holdDateFieldRequired'] == '1') {
                    app.videofiles[v].required.hold_date = true;
                    submitFormBlock = true;
                } else {app.videofiles[v].required.hold_date = false;}
            });
            return submitFormBlock;
        },
        leftSidebarClass: function(index, video) {
            let app = this;
            let sidebarClass = '';
            if(index == app.activeVideoIndex) {
                sidebarClass = 'active';
            }

            if(Object.values(video.required).includes(true)) {
                sidebarClass += ' required';
            }

            return sidebarClass;
        },
        activateDeleteCCFilePopup(video, index) {
            let app = this;
            app.modalTriggerConfirmCCRemove = true;
            app.videoModalDelete = video;
            app.activeVideoIndex = index;
        },
        removeCCFile: function(vid) {
            let app = this;
            let vfo_id = app.videofiles[app.activeVideoIndex].id;
            let actionUrl = '/video/update/' + vfo_id;

            window.axios(
                {
                    method: 'POST',
                    url: actionUrl,
                    data: {
                        id: vid,
                        order_id: app.entryid,
                        CCFileUrl: '',
                        CCFilename: '',
                    }
                }).then(function(response) {
                app.videofiles[app.activeVideoIndex].CCFileUrl = '';
                app.videofiles[app.activeVideoIndex].CCFilename = '';

                app.modalTriggerConfirmCCRemove = false;
                location.reload();
            }).catch(function (error) {
                // handle error
                // console.log('This is the error returned', error);
            });
        },
        openDropzoneUploader: function() {
            if (this.$refs.videoDropzone) {
                this.$refs.videoDropzone.$el.click();
            }
        },
        titleCaseBlur: function (varname, indexval, evt) {
            if(!this.isadmin) {
                var string_split = evt.target.value.toLowerCase().split(" ");
                for (var i = 0; i < string_split.length; i++) {
                    var j = string_split[i].charAt(0).toUpperCase();
                    string_split[i] = j + string_split[i].substr(1);
                }
                evt.target.value = string_split.join(" ");
                this.videofiles[indexval][varname] = string_split.join(" ");
            }
        },
        titleCase: function(varname, evt) {
            if(!this.isadmin) {
                let target = evt.target;
                var start = target.selectionStart;
                var end = target.selectionEnd;
                var string_split = target.value.toLowerCase().split(" ");
                for ( var i = 0; i < string_split.length; i++ )
                {
                    var j = string_split[i].charAt(0).toUpperCase();
                    string_split[i] = j + string_split[i].substr(1);
                }
                target.value = string_split.join(" ");
                target.setSelectionRange(start, end);
            }
        },
        videoDateFormat: function(dateFromDb) {
            let dateFormat = Date(dateFromDb);
            // var year = dateFormat.getFullYear();
            // // console.log(year, 'this is year')
            // var options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
            // // console.log(dateFormat.toLocaleDateString("en-US", options)); // Saturday, September 17, 2016

            // console.log(dateFormat);
            return '2';
        }
    }
}
</script>


<style scoped>
.select2-container--default .select2-results>.select2-results__options {
    max-height: 300px;
}
.active {
    background: lightgray;
}
#closed_caption.form-control.filename {
    padding-right:0;
    height:auto;
}
</style>
